const USER_ID_KEY = 'cacafigurinhas:userId';

const generateShortId = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let id = '';
  for (let i = 0; i < 8; i++) {
    if (i === 4) id += '-';
    id += chars[Math.floor(Math.random() * chars.length)];
  }
  return id; // ex: "abc1-23de"
};

export const getUserId = () => {
  try {
    let id = localStorage.getItem(USER_ID_KEY);
    if (!id) {
      id = generateShortId();
      localStorage.setItem(USER_ID_KEY, id);
    }
    return id;
  } catch {
    return generateShortId();
  }
};

export const setUserId = (id) => {
  try {
    localStorage.setItem(USER_ID_KEY, id);
  } catch {}
};
